import { request } from './http';
import { invalidateReadCache } from './readCache';

export async function getTransferHosePipeTestingAttachments(id) {
    return request(`/testing/transfer-hose-tests/${id}/attachments`);
  }

export async function addTransferHosePipeTestingAttachment(id, { Filename, FileContainer, OriginalFilename } = {}) {
    return request(`/testing/transfer-hose-tests/${id}/attachments`, {
      method: 'POST',
      body: JSON.stringify({ Filename, FileContainer, OriginalFilename: OriginalFilename || null }),
    });
  }

export async function deleteTransferHosePipeTestingAttachment(id, attachmentId) {
    return request(`/testing/transfer-hose-tests/${id}/attachments/${attachmentId}`, {
      method: 'DELETE',
    });
  }

export async function generateTransferHosePipeTestingPdf(recordId) {
    return request('/pdf/generate-and-save-transfer-hose-and-pipe-testing', {
      method: 'POST',
      body: JSON.stringify({ recordId }),
    });
  }

export async function saveHazardousWasteRemoval(data) {
    return request('/hazardous-waste-removal', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function searchEnvironmentalSampling({ siteId, q = '', limit = 25 } = {}) {
    const params = new URLSearchParams();
    if (siteId != null && siteId !== '') params.set('siteId', String(siteId));
    if (q) params.set('q', q);
    if (limit) params.set('limit', String(limit));
    return request(`/testing/environmental-sampling/search?${params}`);
  }

export async function saveEnvironmentalSampling(data) {
    return request('/testing/environmental-sampling', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateEnvironmentalSampling(id, data) {
    return request(`/testing/environmental-sampling/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function saveEnvironmentalLabAnalysis(data) {
    return request('/environmental-lab-analysis', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateEnvironmentalLabAnalysis(id, data) {
    return request(`/testing/environmental-lab-analysis/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function updateCompany(id, data) {
  const result = await request(`/testing/companies/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  invalidateReadCache('companies');
  invalidateReadCache('sites');
  return result;
}

export async function createCompany(data) {
  const result = await request('/testing/companies', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  invalidateReadCache('companies');
  return result;
}

export async function updateSite(id, data) {
  const result = await request(`/testing/sites/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  invalidateReadCache('sites');
  return result;
}

export async function getSiteOpenRecords(id) {
    return request(`/testing/sites/${id}/open-records`);
  }

export async function createSite(data) {
  const result = await request('/testing/sites', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  invalidateReadCache('sites');
  return result;
}

export async function deleteSite(id) {
  const result = await request(`/testing/sites/${id}`, {
    method: 'DELETE',
  });
  invalidateReadCache('sites');
  return result;
}

export async function deleteHazardousWasteRemoval(id) {
    return request(`/testing/hazardous-waste-removal/${id}`, {
      method: 'DELETE',
    });
  }

export const transferHoseAndPipeTestingAttachmentsPdfApi = {
  getTransferHosePipeTestingAttachments,
  addTransferHosePipeTestingAttachment,
  deleteTransferHosePipeTestingAttachment,
  generateTransferHosePipeTestingPdf,
  saveHazardousWasteRemoval,
  searchEnvironmentalSampling,
  saveEnvironmentalSampling,
  updateEnvironmentalSampling,
  saveEnvironmentalLabAnalysis,
  updateEnvironmentalLabAnalysis,
  updateCompany,
  createCompany,
  updateSite,
  getSiteOpenRecords,
  createSite,
  deleteSite,
  deleteHazardousWasteRemoval,
};

